import { EMRData } from "../../../../../Managers/VisualizationManager/ToolBar/Modals/MedicationGraphModalities/Medications";
import { ModalityPage } from "./ModalityPage";
import { TimeSeriesPageManager } from "./TimeSeriesPageManager";

export class ModalityPageManager extends TimeSeriesPageManager<ModalityPage> {
    getPageMaker(): () => ModalityPage { 
        return (): ModalityPage => new ModalityPage(this)
    }
    
	public updateEMRData(emrData: EMRData[]) {
		this.config.emrData = emrData
		this.pages.forEach(page => {
			page.populateEMRData()
			page.clearRenderCache()
		})
	}

	public getEMRData = () => this.config.emrData
}